import React from 'react';
import PropTypes from 'prop-types';
import { DragLayer } from 'react-dnd';
import cn from 'classnames';
import _has from 'lodash/has';
import _isNull from 'lodash/isNull';
import TextCropper from '@omilia/text-cropper';

import ArchivedIcon from 'components/SelectableList/components/ArchivedIcon';
import Warning from 'scenes/Rules/components/List/components/RuleItem/components/Warning';
import Icons from 'scenes/Rules/components/List/components/RuleItem/components/Icons';

import { ruleType } from 'types';
import './style.scss';

function getItemStyles(props) {
  const { currentOffset } = props;
  if (!currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

export class Preview extends React.Component {
  static propTypes = {
    isArchived: PropTypes.bool,
    isSelected: PropTypes.bool,
    item: ruleType,
    number: PropTypes.node,
  };

  renderPreview() {
    const { item, number, isArchived, isSelected } = this.props;
    if (!_has(item, 'rules')) {
      return (
        <div
          styleName={cn('item', {
            'is-archived': isArchived,
            'is-disabled': !item.enabled,
            'is-pre-selected': true,
            'is-selected': isSelected,
          })}
        >
          <div styleName="name-block">
            {number}
            <TextCropper styleName="cropper" text={item.name}>
              <span data-test="name" styleName="name">
                {item.name}
              </span>
            </TextCropper>
            {!_isNull(item.xpack) && item.xpack ? <sup>XP</sup> : null}
          </div>
          <div styleName="item__icons">
            {!isArchived && <Icons enabled={item.enabled} />}
            {isArchived && <ArchivedIcon name="Rule" />}
            {(item.actions.length === 0 ||
              item.matching_pattern_elements.length === 0) && <Warning />}
          </div>
        </div>
      );
    }
    return (
      <div
        styleName={cn('group', {
          'is-archived': isArchived,
          'is-pre-selected': true,
          'is-selected': isSelected,
          'is-empty': item.rules.length === 0,
        })}
      >
        <div
          styleName={cn('item', {
            'is-disabled': !item.enabled,
          })}
        >
          <div styleName="name-block">
            {number}
            <span
              className="icon-triangle-arrow-up"
              styleName={cn('caret', {
                'is-disabled': !item.rules.length,
              })}
            />
            <TextCropper styleName="cropper" text={item.name}>
              <div data-test="name" styleName="name">
                <span className="icon-rule-group rule" /> {item.name}
                <span
                  styleName={cn('amount', {
                    'is-filled': item.rules.length > 0,
                  })}
                >
                  (<span> {item.rules.length || 'empty'} </span>)
                </span>
              </div>
            </TextCropper>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div styleName="preview">
        <div style={getItemStyles(this.props)}>{this.renderPreview()}</div>
      </div>
    );
  }
}

function collect(monitor) {
  return {
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
    item: monitor.getItem(),
  };
}

export default DragLayer(collect)(Preview);
